import ProtectedRoute from '../../components/ProtectedRoute';
import DepositPage from './components/DepositPage';

import { DEPOSIT_PATH } from '../../constants/routes';

const Routes = [
  {
    path: DEPOSIT_PATH,
    Component: ProtectedRoute,
    children: [
      {
        index: true,
        Component: DepositPage,
      },
      {
        path: '*',
        Component: DepositPage,
      },
    ],
  },
];

export default {
  Routes,
};
